import { useState, useContext, useEffect } from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Menu,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import QuestionGroupDialog from "./QuestionGroupDialog";

import ProfileQuestionContext from "../../../contexts/ProfileQuestionContext";
import request from "../../../utilities/requests";

const QuestionGroups = ({ clear, refresh }) => {
  const {
    questionGroups,
    questionGroup,
    setQuestionGroup,
    setQuestionGroupQuestions,
    setQuestionDialogOpen,
    setRequiredQuestions,
    setQuestionGroupMessage,
    org
  } = useContext(ProfileQuestionContext);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectOpen, setSelectOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [anchor, setAnchor] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (questionGroup) {
      setSelectedGroup(questionGroup);
      getQuestionGroup();
    } else {
      setSelectedGroup("");
    }
  }, [questionGroup]);

  useEffect(() => {
    handleClear();
  },[org])

  const getQuestionGroup = async () => {
    const result = await request(
      `questiongroups?questionGroupId=${questionGroup}`
    );
    if (result.success) {
      setQuestionGroupQuestions(result?.questionGroup?.questions);
      if (result?.questionGroup?.required) {
        setRequiredQuestions(result.questionGroup.required);
      }
      if (result.message) {
        setQuestionGroupMessage(result.message);
      }
    }
  };

  const handleChange = async (value) => {
    if (selectedGroup) {
      await handleClear();
    }
    setQuestionGroup(value);
    setSelectOpen(false);
  };

  const handleClear = async () => {
    setQuestionGroupQuestions([]);
    setQuestionGroup(null);
    setSelectedGroup("");
    setQuestionGroupMessage("");
    clear();
    setMenuOpen(false);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        gap: 20,
      }}
    >
      <div style={{ display: "flex", flex: 6, justifyContent: "center" }}>
        <Button
          variant="contained"
          sx={{
            whiteSpace: "nowrap", // Prevent text wrapping
            fontSize: { xs: "0.75rem", sm: ".9rem" }, // Adjust font size for smaller screens
            padding: { xs: "4px 8px", sm: "6px 16px" }, // Adjust padding for smaller screens
          }}
          onClick={() => setQuestionDialogOpen(true)}
        >
          New Question
        </Button>
      </div>
      <div
        style={{
          display: "flex",
          flex: 6,
          justifyContent: "space-around",
          // flexWrap: "wrap",
          alignItems: "center",
          padding: 10
        }}
      >
        <FormControl sx={{ width: {xs: 180, sm: 250} }}>
          <InputLabel sx={{ backgroundColor: "white", top: -5,  fontSize: { xs: "0.9rem", sm: "1rem" } }}>
            Question Groups
          </InputLabel>
          <Select
            value={selectedGroup}
            label="Question Groups"
            onChange={(e) => {
              handleChange(e.target.value);
            }}
            open={selectOpen}
            onOpen={() => setSelectOpen(true)}
            onClose={(e) => setSelectOpen(false)}
            style={{ height: 45 }}
          >
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleClear();
                setSelectOpen(false);
                setDialogOpen(true);
                // setSelectedGroup("");
              }}
            >
              + Create New
            </MenuItem>
            {questionGroups.map((option) => {
              return (
                <MenuItem key={option._id} value={option._id}>
                  {option.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        {questionGroup ? (
          <div
            style={{ padding: 10, cursor: "pointer" }}
            onClick={(e) => {
              setMenuOpen(true);
              setAnchor(e.currentTarget);
            }}
          >
            <MoreVertIcon style={{}} />
          </div>
        ) : (
          <></>
        )}
      </div>
      <Menu
        anchorEl={anchor}
        open={menuOpen}
        onClose={() => {
          setMenuOpen(false);
        }}
      >
        <MenuItem onClick={handleClear}>Clear</MenuItem>
        <MenuItem onClick={() => setDialogOpen(true)}>Edit</MenuItem>
      </Menu>
      <QuestionGroupDialog
        open={dialogOpen}
        close={() => {
          setDialogOpen(false);
          refresh();
        }}
      />
    </div>
  );
};

export default QuestionGroups;
